<template>
  <div style="width:100%;">
    <el-select
      v-model="groupId"
      style="vertical-align: top;width:100%"
      placeholder="请选择资讯分组">
      <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.v"
        :value="item.id">
      </el-option>
    </el-select>
  </div>
</template>
<script>
import Common from '@/service/common'
export default {
  name: 'InfoGroupSelect',
  props: {
    value: { required: true }
  },
  data() {
    return { list: [] }
  },
  computed: {
    groupId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      Common.getkeyvalues({ topic: 'info', pageNum: 1, pageSize: 100 })
        .then(res => {
          const { result, message, records } = res.data
          if ([0, 13].includes(result)) {
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>
